import type {IntlShape} from 'react-intl';
import {callSurfaceMessages as m} from '../messages';
import type {CallLeg} from './types';

export const legNameOf = (leg: CallLeg, intl: IntlShape): string =>
    leg.identity.name ?? leg.identity.number ?? (leg.engine === 'sip' ? leg.dialNumber : undefined) ?? intl.formatMessage(m.unknownCaller);
